// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBboFYD941m096qu7AeK2iLjwtwiCYDj7s",
  authDomain: "react-nurova-ecom.firebaseapp.com",
  projectId: "react-nurova-ecom",
  storageBucket: "react-nurova-ecom.firebasestorage.app",
  messagingSenderId: "1068107100738",
  appId: "1:1068107100738:web:c16f3f096b44c06649f3db",
  measurementId: "G-QXX1Q3L8CB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
// Firebase services export
export const db = getFirestore(app);
export const auth = getAuth(app);